var map = {
	"./Atkins-01.svg": 5861,
	"./Dell.svg": 5516,
	"./IMTMA.svg": 9739,
	"./NJM.svg": 3110,
	"./TWI.svg": 355,
	"./accenture-01.svg": 4813,
	"./amazon.svg": 7825,
	"./asense.svg": 5872,
	"./britannia.svg": 257,
	"./cashfree.svg": 6014,
	"./datamatics.svg": 9292,
	"./fastrack.svg": 9290,
	"./ge.svg": 3517,
	"./hdfc.svg": 7212,
	"./metricstream.svg": 3265,
	"./microsoft.svg": 7255,
	"./pinnacle films.svg": 1596,
	"./shipsy.svg": 2835,
	"./tally.svg": 9129,
	"./tanishq.svg": 9035,
	"./vymo.svg": 2414,
	"./woodenstreets.svg": 3253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 631;